import { GET } from '../request'

export const getLogs = ({ fecha, usuario }) =>
  GET('/api/core/log/registro-acceso/list', { fecha, usuario })
